import { Box, Button, Typography } from "@mui/material"
import React from "react"
import style from "./style"
import SubHeader from "../../../../../components/SubHeader"
import color from "../../../../../constants/color"
import BankTransactionsList from "./BankTransactionList"

const ViewBankTransactionsPage = () => {
  return(
    <>
      <Box px="15px" pt="20px" display={{xs: "block", md:"flex"}} justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={style.leaveHeading}>Bank Transactions</Typography>

        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }} mt={{xs:2, md: 0}}>
          <Button variant="contained" color="success" sx={style.csvBtns} >
            {"CSV"}
          </Button>

          <Button variant="contained" color="success" sx={style.checkinBtns} >
            {"Import PDF"}
          </Button>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: color.card, m: 2, borderRadius: "20px" }}>
        <SubHeader
          isShow={false}
          search
          sortBy
        />
        <BankTransactionsList />
      </Box>

    </>
  )
}

export default ViewBankTransactionsPage